<div class="login">
    <div class="container mx-auto">
        <div class="form login-backoffice flex items-center justify-center h-[100vh] w-full">
            <form class="w-1/2" [formGroup]="formLogin" (ngSubmit)="onLogin()">
                <div class="flex flex-col gap-8">
                    <div class="w-full">
                        <h1 class="text-center font-mono uppercase lg:text-4xl text-2xl text-white">Accedi</h1>
                    </div>
                    <div class="w-full">
                        <input type="text" pInputText placeholder="Username" formControlName="username" required />
                    </div>
                    <div class="w-full">                                                
                        <p-password [toggleMask]="true" formControlName="password" placeholder="Password" [feedback]="false" class="w-full grid" autocomplete />
                    </div>
                    <button class="button p-3 w-full border border-[#ccc] font-medium" type="submit" [disabled]="!formLogin.valid">Accedi</button>
                </div>
            </form>
        </div>
    </div>
</div>